import { ComponentOptions } from '../types';
import { ComponentVendor } from './component-vendor.class';
import { ComponentVendorData, ComponentVendorsData, ComponentVendorsDataIn } from './types';

import { vendorData } from '../data/vendor.data';

export class ComponentVendors extends Array<ComponentVendor> {
	#userEmail: string;

	constructor (options: ComponentOptions<ComponentVendorsDataIn>) {
		super();

		this.#userEmail = options?.userEmail ?? 'SYSTEM';

		if (options.dataIn?.length > 0) {
			options.dataIn.forEach((n) => this.push(new ComponentVendor({ ...options, dataIn: n })));
		} else {
			this.load();
		}
	}

	/**
	 *
	 * @param newComponentVendorData ComponentVendorData of component vendor to add
	 * @returns unique identified of added component vendor
	 */
	public add (newVendorData: Partial<ComponentVendorData>): string {
		const newRecord = new ComponentVendor({ userEmail: this.#userEmail, dataIn: newVendorData });
		this.push(newRecord);
		return newRecord.id;
	}

	/**
	 *
	 * @param id category id to look up
	 * @returns Category
	 */
	public findById (id: string): ComponentVendor {
		const category = this.find((record) => record.id === id) as ComponentVendor || null;
		return category;
	}

	// loads json, returns record count loaded
	// TODO: loaders should be an injectable interface to allow for external sources
	public load (): number {
		// purge before load
		if (this.length > 0) this.splice(0, this.length);

		// load data
		let loadCounter = 0;
		vendorData.forEach((vendor) => {
			loadCounter++;
			this.add(vendor);
		});

		return loadCounter;
	}

	/**
	 *
	 * @returns serialized data representing class state for persistence
	 */
	public serialize ():ComponentVendorsData {
		return this.map((record: ComponentVendor) => record.serialize());
	}
}
